import BaseService from './baseService'
import { Currency } from '@/types/currency'
import EndPoints from '@/constants/dxApiEndpoints'

class CurrencyService extends BaseService {
  getCurrencies = async (): Promise<Currency[]> => {
    const url: string = EndPoints.Currencies()
    const response = await this.apiClient.get<{ data: Currency[] }>(url)
    const currencies = response.data

    return currencies.map((currency: Currency) => ({
      id: currency.id,
      code: currency.code,
      displayName: currency.displayName,
      currencyOffset: currency.currencyOffset
    }))
  }

  getBusinessProfileCurrency = async (
    businessProfileId: number,
    currencyId: number
  ): Promise<Currency> => {
    const url: string = EndPoints.BusinessProfileCurrency(
      businessProfileId,
      currencyId
    )
    const response = await this.apiClient.get<{ data: Currency }>(url)
    return response.data
  }
}

export default CurrencyService
